import React from 'react';
import PropTypes from 'prop-types';
import Grid from "@material-ui/core/Grid";
import DripCampaignRateBox from "./DripCampaignRateBox";
import {useTranslation} from 'react-i18next';

const DripCampaignRatesRow = ({record}) => {
    const {t} = useTranslation();

    // Use report data if available, otherwise fall back to legacy fields
    const openRate = (record.report && record.report.ratioRead) || record.openRate || 0;
    const clickRate = (record.report && record.report.ratioClick) || record.clickRate || 0;
    const uniqueOpens = (record.report && record.report.contactOpenActions) || record.openedEnrollments || 0;
    const totalOpens = (record.report && record.report.totalOpenActions) || record.openedEnrollments || 0;
    const uniqueClicks = (record.report && record.report.contactClickActions) || record.clickedEnrollments || 0;
    const totalClicks = (record.report && record.report.totalClickActions) || record.clickedEnrollments || 0;
    const lastOpenedAt = (record.report && record.report.lastOpenActionAt) || record.lastOpenedAt;
    const lastClickedAt = (record.report && record.report.lastClickActionAt) || record.lastClickedAt;

    return (
        <Grid container spacing={24}>
            <Grid item xs={6}>
                <DripCampaignRateBox
                    label={t('Open rate')}
                    ratio={openRate}
                    uniqueActions={uniqueOpens}
                    totalActions={totalOpens}
                    lastOccurrence={lastOpenedAt}
                />
            </Grid>
            <Grid item xs={6}>
                <DripCampaignRateBox
                    label={t('Click rate')}
                    ratio={clickRate}
                    uniqueActions={uniqueClicks}
                    totalActions={totalClicks}
                    lastOccurrence={lastClickedAt}
                />
            </Grid>
        </Grid>
    );
};

DripCampaignRatesRow.propTypes = {
    record: PropTypes.object.isRequired,
};

export default DripCampaignRatesRow;